import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_REVENUE_MEMBERSHIP_IDENTIFIED_LOGIN_GATE = defineFcm('revenue_membership_identified_login_gate')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'Membership Join Page and Membership Offer',
		description:
			'Gates the experiment that asks identified (email-link) sessions to log in before vaulting a payment method for a membership (variant_1); when unset or disabled, as in control, they vault as before the gate existed',
		template: {
			enabled: false,
			experimentName: '',
		},
	});
